import React, { useEffect } from 'react';
import {
  Container,
  Paper,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';

// Configuration - should match your environment
const CENTRAL_APP_URL = import.meta.env.VITE_CENTRAL_APP_URL || 'https://beta.creativetoolbox.ai';

const Login: React.FC = () => {
  useEffect(() => {
    // Auto-redirect to central auth if no manual interaction needed
    // Uncomment this if you want automatic redirect
    // handleSSOLogin();
  }, []);

  const handleSSOLogin = () => {
    // Encode the current origin as the redirect URL
    const redirectUrl = encodeURIComponent(window.location.origin + '/sync-session');
    const loginUrl = `${CENTRAL_APP_URL}/login?redirectTo=${redirectUrl}`;
    
    console.log('Redirecting to central auth:', loginUrl);
    
    // Redirect to central authentication app
    window.location.href = loginUrl;
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          {/* App Branding */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography component="h1" variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Creative Studio
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The Creative Assistant
            </Typography>
          </Box>

          <Typography component="h2" variant="h5" align="center" gutterBottom sx={{ mb: 3 }}>
            Welcome Back
          </Typography>
          
          <Typography variant="body1" align="center" sx={{ mb: 4, color: 'text.secondary' }}>
            Sign in with your Creative Toolbox account to access your creative agents and continue your projects.
          </Typography>

          {/* SSO Login Button */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleSSOLogin}
            startIcon={<LoginIcon />}
            sx={{ 
              mt: 2, 
              mb: 3,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600
            }}
          >
            Sign In with Creative Toolbox
          </Button>

          <Typography variant="caption" align="center" sx={{ display: 'block', color: 'text.secondary' }}>
            You'll be redirected to our secure authentication system
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;